export const TOKEN_TYPE = "";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const CONTENT_TYPE = 'Content-Type';
export const ACCESS_CONTROL = 'Access-Control-Allow-Origin';
